import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BBResponseContainer } from './response-container';
import { Subject, of } from 'rxjs';
import { BuildInfo } from '../BuildInfo';
import { catchError, tap, timeout } from 'rxjs/operators';

@Injectable()
export class CarrierService {

  defaultTimeout = 600000;
  noValue = { data: { Build: { Number: 'N/A' } } };

  constructor(private http: HttpClient) { }

  getBuildInfo() {
    return this.http.get<BuildInfo>("/assets/TFS-Build-Report.json").pipe(catchError(error => of({ Build: { Number: 'unknown build' } })));
  }

  getServiceBuildInfo(serviceHostUrl: string) {
    let url : string;
    if (serviceHostUrl === environment.BB_STORAGE_URL ){
      url = serviceHostUrl + "utils/version";
      return this.http.get<any>(url).pipe(catchError(error => of(this.noValue)));
    }
    else{
      url = serviceHostUrl + "build";
      return this.http.get<BBResponseContainer>(url).pipe(catchError(error => of(this.noValue)));
    }
  }

  //shared Methods
  // Observable string sources
  private emitChangeSource = new Subject<any>();
  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();
  // Service message commands
  emitChange(change: any) {
    this.emitChangeSource.next(change);
  }

}
